export default __webpack_public_path__ + "static/media/metamask_steps_6.0550e167.png";